import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography, 
  Box
} from '@mui/material';
import { openInExternalBrowser } from '../utils/browserDetect';

/**
 * 인앱 브라우저 감지 시 표시되는 모달 컴포넌트
 * @param {boolean} open - 모달 표시 여부
 * @param {Function} onClose - 모달 닫기 핸들러
 * @returns {JSX.Element}
 */
function InAppBrowserModal({ open, onClose }) {
  const handleOpenExternal = () => {
    openInExternalBrowser();
    if (onClose) onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        외부 브라우저로 접속 필요
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ textAlign: 'center', py: 1 }}>
          <Typography variant="body1" paragraph>
            카카오톡이나 다른 앱 브라우저에서는 구글 로그인이 제한되어 있습니다.
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Safari, Chrome 등 기본 브라우저에서 접속하시면 모든 기능을 이용하실 수 있습니다.
          </Typography>
          
          <Box 
            component="img" 
            src="/images/browser-guide.png" 
            alt="브라우저 가이드"
            sx={{ 
              maxWidth: '100%', 
              height: 'auto',
              maxHeight: '180px',
              mb: 2,
              display: 'none' // 이미지가 없는 경우 숨김 처리, 이미지 준비되면 제거
            }}
          />
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button 
          onClick={onClose} 
          color="inherit"
          sx={{ mr: 1 }}
        >
          취소
        </Button>
        <Button 
          onClick={handleOpenExternal}
          variant="contained"
          sx={{
            bgcolor: 'grey.900',
            color: 'white',
            '&:hover': { bgcolor: 'grey.800' }
          }}
        >
          외부 브라우저로 열기
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default InAppBrowserModal; 